var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.config
    ? _c(
        "div",
        { key: _setup.elementKey, staticClass: "calendar-section" },
        [
          _c(_setup.CInput, {
            attrs: {
              value: _setup.config.monthNames.split(",").join(", "),
              type: "text",
              label: "Month Names",
              placeholder: "January, February, March, ...",
              disabled: _setup.disabled,
            },
            on: { input: _setup.onMonthNamesChange },
          }),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            attrs: {
              value: _setup.config.yearMonthCombined,
              "no-icon": "",
              type: "radio",
              wide: "",
              items: _setup.STYLING_MODES,
              disabled: _setup.disabled,
            },
            on: { input: _setup.onStylingModeChange },
          }),
          _vm._v(" "),
          _setup.config.yearMonthCombined
            ? _c(_setup.CalendarTitleStyleFields, {
                attrs: {
                  prefix: "yearMonth",
                  config: _setup.config,
                  disabled: _setup.disabled,
                },
                on: { update: _setup.update },
              })
            : [
                _c(_setup.CalendarFieldTitle, [_vm._v("Month")]),
                _vm._v(" "),
                _c(_setup.CalendarTitleStyleFields, {
                  attrs: {
                    prefix: "month",
                    config: _setup.config,
                    disabled: _setup.disabled,
                  },
                  on: { update: _setup.update },
                }),
                _vm._v(" "),
                _c(_setup.CalendarFieldTitle, [_vm._v("Year")]),
                _vm._v(" "),
                _c(_setup.CalendarTitleStyleFields, {
                  attrs: {
                    prefix: "year",
                    config: _setup.config,
                    disabled: _setup.disabled,
                  },
                  on: { update: _setup.update },
                }),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }